import { render, staticRenderFns } from "./StorageModuleFormList.vue?vue&type=template&id=71c909be&"
import script from "./StorageModuleFormList.vue?vue&type=script&lang=ts&"
export * from "./StorageModuleFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports